import {createLogger, createRedactor} from '@pexip/logger';
import {setLogger as setMeeSdkLogger} from '@pexip/vpaas-sdk';
import {setLogger as setSignalLogger} from '@pexip/signal';
import {setLogger as setPeerConnectionLogger} from '@pexip/peer-connection';
import {setLogger as setMediaComponentsLogger} from '@pexip/media-components';
import {setLogger as setMediaControlLogger} from '@pexip/media-control';
import {setLogger as setMediaLogger} from '@pexip/media';
import {setLogger as setMeeApiLogger} from '@pexip/vpaas-api';
import {setLogger as setSocketLogger} from '@pexip/socket-manager';

const REDACTED = '[REDACTED]';
const redactor = createRedactor({
    defaultReplaceTo: REDACTED,
    keysToRedact: [
        ['access_token', REDACTED],
        ['participant_secret', REDACTED],
        ['token', REDACTED],
    ],
});
export const rootLogger = createLogger({
    fileName: 'mee',
    redactor,
});

export const logger = rootLogger.child({name: 'mee'});
setMeeSdkLogger(rootLogger.child({name: 'vpaas-sdk'}));
setSignalLogger(rootLogger.child({name: 'signal'}));
setPeerConnectionLogger(rootLogger.child({name: 'peer-connection'}));
setMediaComponentsLogger(rootLogger.child({name: 'media-components'}));
setMediaLogger(rootLogger.child({name: 'media'}));
setMediaControlLogger(rootLogger.child({name: 'media-control'}));
setMeeApiLogger(rootLogger.child({name: 'vpaas-api'}));
setSocketLogger(rootLogger.child({name: 'socket-manager'}));

window.pexDebug = {
    ...window.pexDebug,
    dumpLog: rootLogger.downloadLog,
    get logEvents() {
        return rootLogger.logEvents;
    },
};
